import type { IContactCompany } from './ContactCompany.interface';
import ContactCompanyInformation from './ContactCompanyInformation';
import ContactCompanyDetails from './ContactCompanyDetails';

export default class ContactCompany implements IContactCompany {
  information: ContactCompanyInformation;
  contact: ContactCompanyDetails;

  static build = (data: IContactCompany) => new ContactCompany(data);
  static blank = () => new ContactCompany();

  /**
   * Constructor
   * @param {IContactCompany} data
   */
  constructor(data?: IContactCompany) {
    this.information = new ContactCompanyInformation(data?.information);
    this.contact = new ContactCompanyDetails(data?.contact);
  }
}
